import { create } from "zustand";
import { persist } from "zustand/middleware";
import { authApi, type AuthUser } from "@/api/auth";
import { getAccountIdFromUrl } from "@/lib/constants";

interface AuthState {
  token: string | null;
  user: AuthUser | null;
  idAccount: string | null;
  language: string;
  idWl: string;
  isAuthenticated: boolean;
  loginError: string | null;
  isLoggingIn: boolean;
  login: (email: string, password: string) => Promise<void>;
  logout: () => void;
  initAccount: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      token: null,
      user: null,
      idAccount: getAccountIdFromUrl(),
      language: "pt-br",
      idWl: "1",
      isAuthenticated: false,
      loginError: null,
      isLoggingIn: false,

      login: async (email, password) => {
        // Ensure idAccount is set before making the API call
        if (!get().idAccount) {
          set({ idAccount: getAccountIdFromUrl() });
        }
        set({ loginError: null, isLoggingIn: true });
        try {
          const res = await authApi.login(email, password);
          const { token, user } = res.data;
          set({
            token,
            user,
            isAuthenticated: true,
            loginError: null,
            isLoggingIn: false,
          });
        } catch (err) {
          const message =
            err instanceof Error ? err.message : "Erro ao realizar login";
          set({ loginError: message, isLoggingIn: false });
          throw err;
        }
      },

      logout: () => {
        set({
          token: null,
          user: null,
          idAccount: null,
          isAuthenticated: false,
          loginError: null,
          isLoggingIn: false,
        });
      },

      initAccount: () => {
        const idAccount = getAccountIdFromUrl();
        set({ idAccount });
      },
    }),
    {
      name: "gchat-auth",
      partialize: (state) => ({
        token: state.token,
        user: state.user,
        idAccount: state.idAccount,
        language: state.language,
        idWl: state.idWl,
        isAuthenticated: state.isAuthenticated,
      }),
      onRehydrateStorage: () => (state) => {
        // Ensure idAccount is always set after rehydration
        if (state && !state.idAccount) {
          state.idAccount = getAccountIdFromUrl();
        }
      },
    },
  ),
);
